/* Ardor Sticker Builder: the AI design drawer ("AI design" on the tool rail). Ardor Printing. New Oct 11, 2026 (AI-STICKER).
Fills the drawer panel [data-sai-host] that sections/ardor-sticker-studio-ws-ai.liquid adds to the studio drawer. Talks to the
same AI server routes as the AI sticker idea generator page (/pages/sticker-idea-generator, assets/ardor-idea.js), no server
change: GET /api/quota, POST /api/generate { idea, style, visitor, email, token }, GET /img/<id>. Same visitor id and email
(localStorage wsIdeaVisitor / wsIdeaEmail), same invisible Cloudflare Turnstile check and the same email unlock (Shopify
customer form tagged newsletter, idea-generator, ardor-sticker-builder), so free ideas are shared with that page. Designs are
kept in sessionStorage wsIdeaHistory like the idea page does, so the full generator shows them too.
"Use this design" fetches /img/<id> and hands it to window.ArdorStickerStudio.placeIdea() (assets/ardor-sticker-ai-studio.js),
the same code the ?idea=<id> hand-off from the idea page runs, so the design lands on the sticker the same way without
leaving the page. */
(function () {
  'use strict';
  var root = document.querySelector('[data-wss]');
  var host = root && root.querySelector('[data-sai-host]');
  if (!host || host.__sai) return;
  host.__sai = true;

  var API = String(host.getAttribute('data-api') || '').replace(/\/+$/, '');
  var SITEKEY = String(host.getAttribute('data-turnstile') || '');
  var AI_PAGE = String(host.getAttribute('data-page') || '/pages/sticker-idea-generator');
  var MAX = 300;
  var STYLES = [
    ['cartoon', 'Cartoon', 'Bold outlines, bright colors', ''],
    ['retro', 'Retro', '70s colors, vintage badge', ''],
    ['kawaii', 'Kawaii', 'Cute, pastel, big eyes', ''],
    ['text', 'Bold text', 'Words, quotes, logos', 'Aa']
  ];
  var EXAMPLES = ['A pickle surfing a rainbow wave', 'A grumpy cactus in sunglasses', 'A coffee cup lifting weights', 'A cat astronaut eating ramen'];
  var LOADING = ['Sketching your idea…', 'Inking the outlines…', 'Mixing the colors…', 'Trimming the die-cut edge…', 'Peeling the backing…', 'Almost there…'];
  var SPARK = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 1.5c.6 5 2.8 7.8 9 9.2v.6c-6.2 1.4-8.4 4.2-9 9.2h-.6c-.6-5-2.8-7.8-9-9.2v-.6c6.2-1.4 8.4-4.2 9-9.2z"></path></svg>';

  function lget(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function lset(k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }
  function sget(k) { try { return JSON.parse(window.sessionStorage.getItem(k) || 'null'); } catch (e) { return null; } }
  function sset(k, v) { try { window.sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }

  var visitor = lget('wsIdeaVisitor');
  if (!visitor || !/^[a-zA-Z0-9_-]{8,64}$/.test(visitor)) {
    visitor = ((window.crypto && crypto.randomUUID) ? crypto.randomUUID() : String(Date.now()) + Math.random().toString(36).slice(2)).replace(/[^a-zA-Z0-9_-]/g, '');
    lset('wsIdeaVisitor', visitor);
  }
  var email = lget('wsIdeaEmail') || '';
  var S = { style: 'cartoon', idea: '', ideaId: '', images: [], selected: null, busy: false, ideasLeft: null, editsLeft: null, hasEmail: !!email, pending: null, off: false, started: false, timer: 0 };
  var ui = {};

  function $(s) { return host.querySelector(s); }
  function $$(s) { return [].slice.call(host.querySelectorAll(s)); }
  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function clean(t) { return String(t || '').replace(/\s+/g, ' ').trim(); }
  function track(name, data) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, Object.assign({ source: 'sticker-builder' }, data || {})); } catch (e) {}
  }
  function studio() { return window.ArdorStickerStudio || null; }
  function wide() { return window.innerWidth >= 990; }

  // ---------- server (same routes and bodies as assets/ardor-idea.js) ----------
  function api(path, body, ms) {
    var opts = body ? { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) } : {};
    var ctl = window.AbortController ? new AbortController() : null, t = 0;
    if (ctl) { opts.signal = ctl.signal; t = setTimeout(function () { ctl.abort(); }, ms || 150000); }
    return fetch(API + path, opts).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        clearTimeout(t);
        if (!j || typeof j !== 'object') j = {};
        if (!r.ok) { if (!j.error) j = { error: 'server', message: 'Something went wrong on our side. Please try again.' }; j.ok = false; }
        return j;
      });
    }, function (e) {
      clearTimeout(t);
      return e && e.name === 'AbortError' ? { ok: false, error: 'timeout', message: 'This is taking longer than usual. Please try again.' } : { ok: false, error: 'network', message: 'Check your connection and try again.' };
    });
  }
  function quota() {
    return api('/api/quota?visitor=' + encodeURIComponent(visitor) + (email ? '&email=' + encodeURIComponent(email) : ''), null, 20000).then(function (q) {
      if (!q.ok) return q;
      if (q.enabled === false) { S.off = true; ui.go.disabled = true; showErr('The idea generator is taking a short break. Please try again later.'); }
      S.ideasLeft = q.ideasLeft; S.editsLeft = q.editsLeft; S.hasEmail = !!q.hasEmail;
      setQuota();
      return q;
    });
  }

  // ---------- Turnstile: explicit render, invisible, a fresh token for every request ----------
  var tsReady = null, tsWidget = null, tsResolve = null;
  function loadTurnstile() {
    if (!SITEKEY) return Promise.resolve(false);
    if (tsReady) return tsReady;
    tsReady = new Promise(function (res) {
      if (window.turnstile && window.turnstile.render) { res(true); return; }
      window.saiTurnstileLoaded = function () { res(true); };
      var s = document.createElement('script');
      s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit&onload=saiTurnstileLoaded';
      s.async = true; s.defer = true;
      s.onerror = function () { res(false); };
      document.head.appendChild(s);
    });
    return tsReady;
  }
  function botToken() {
    return loadTurnstile().then(function (ok) {
      if (!ok || !window.turnstile) return '';
      return new Promise(function (res) {
        tsResolve = res;
        var take = function (t) { var r = tsResolve; if (r) { tsResolve = null; r(t || ''); } };
        try {
          if (tsWidget === null) tsWidget = window.turnstile.render(ui.ts, { sitekey: SITEKEY, execution: 'execute', appearance: 'interaction-only', callback: take, 'error-callback': function () { take(''); } });
          else window.turnstile.reset(tsWidget);
          window.turnstile.execute(tsWidget);
        } catch (e) { take(''); }
        setTimeout(function () { if (tsResolve === res) take(''); }, 45000);
      });
    });
  }

  // ---------- UI ----------
  function build() {
    host.innerHTML =
      '<div class="sai">' +
      '<p class="wss__hint sai-lead">Describe your sticker and pick a style. Our AI draws 4 designs in about 30 seconds. Tap one to put it on your sticker, then move or resize it.</p>' +
      '<label class="wss__label" for="sai-idea">Your sticker idea</label>' +
      '<div class="sai-box"><textarea id="sai-idea" class="wss__input sai-idea" rows="3" maxlength="' + MAX + '" autocomplete="off" placeholder="e.g. a raccoon eating pizza in outer space" data-sai-idea></textarea>' +
      '<span class="sai-count" data-sai-count aria-hidden="true">0/' + MAX + '</span></div>' +
      '<div class="sai-ex" data-sai-exes><span>Try:</span></div>' +
      '<div class="wss__label sai-label" id="sai-style-label">Style</div>' +
      '<div class="sai-styles" role="radiogroup" aria-labelledby="sai-style-label" data-sai-styles></div>' +
      '<p class="sai-note" data-sai-style-note></p>' +
      '<p class="sai-err" data-sai-err role="alert" hidden></p>' +
      '<div class="sai-gate" data-sai-gate hidden>' +
      '<b class="sai-gate__title">You\'re on a roll!</b>' +
      '<p>Add your email to unlock 10 sticker ideas a day. We\'ll send you sticker deals too.</p>' +
      '<div class="sai-gate__row"><input class="wss__input" type="email" autocomplete="email" placeholder="you@example.com" aria-label="Email" data-sai-email>' +
      '<button type="button" class="wss__btn" data-sai-email-go>Unlock</button></div>' +
      '<p class="sai-err" data-sai-gate-err role="alert" hidden></p>' +
      '<small>By continuing you agree to get emails from Ardor Printing. Unsubscribe anytime.</small>' +
      '</div>' +
      '<button type="button" class="wss__btn wss__btn--yellow wss__btn--block sai-go" data-sai-go>' + SPARK + '<span data-sai-go-label>Make my stickers</span></button>' +
      '<p class="sai-quota" data-sai-quota></p>' +
      '<div class="sai-ts" data-sai-ts></div>' +
      '<div class="sai-results" data-sai-results hidden>' +
      '<p class="sai-status" data-sai-status role="status" aria-live="polite"></p>' +
      '<div class="sai-progress" data-sai-progress hidden><i></i></div>' +
      '<div class="sai-grid" data-sai-grid aria-label="Sticker designs"></div>' +
      '<button type="button" class="wss__btn wss__btn--sm sai-again" data-sai-again>Try 4 new versions</button>' +
      '<p class="sai-fine">By using a design you confirm it doesn\'t copy anyone else\'s characters, logos or likeness.</p>' +
      '</div>' +
      '<p class="wss__hint sai-more">Want changes to a design? <a href="' + esc(AI_PAGE) + '" data-sai-page>Open the full AI generator</a>.</p>' +
      '</div>';
    ui.input = $('[data-sai-idea]'); ui.count = $('[data-sai-count]'); ui.go = $('[data-sai-go]'); ui.goLabel = $('[data-sai-go-label]');
    ui.quota = $('[data-sai-quota]'); ui.err = $('[data-sai-err]'); ui.gate = $('[data-sai-gate]'); ui.email = $('[data-sai-email]');
    ui.gateErr = $('[data-sai-gate-err]'); ui.results = $('[data-sai-results]'); ui.status = $('[data-sai-status]');
    ui.progress = $('[data-sai-progress]'); ui.grid = $('[data-sai-grid]'); ui.again = $('[data-sai-again]'); ui.ts = $('[data-sai-ts]');
    ui.note = $('[data-sai-style-note]');
    var ex = $('[data-sai-exes]');
    EXAMPLES.forEach(function (t) {
      var b = document.createElement('button'); b.type = 'button'; b.className = 'sai-chip'; b.setAttribute('data-sai-ex', t); b.textContent = t;
      ex.appendChild(b);
    });
    var st = $('[data-sai-styles]');
    STYLES.forEach(function (s) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'sai-style'; b.setAttribute('role', 'radio'); b.setAttribute('data-sai-style', s[0]); b.title = s[2];
      b.innerHTML = '<span class="sai-style__art sai-style__art--' + s[0] + '" aria-hidden="true"><i>' + esc(s[3]) + '</i></span><b>' + esc(s[1]) + '</b>';
      st.appendChild(b);
    });
    setStyle(S.style);
    host.addEventListener('click', onClick);
    ui.input.addEventListener('input', function () { syncCount(); showErr(''); });
    ui.input.addEventListener('keydown', function (e) { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); generate(false); } });
    ui.email.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); useEmail(); } });
    st.addEventListener('keydown', function (e) {
      if (['ArrowRight', 'ArrowLeft', 'ArrowDown', 'ArrowUp'].indexOf(e.key) < 0) return;
      e.preventDefault();
      var btns = $$('[data-sai-style]'), i = btns.indexOf(document.activeElement); if (i < 0) i = 0;
      var n = btns[(i + (e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : -1) + btns.length) % btns.length];
      setStyle(n.getAttribute('data-sai-style')); n.focus();
    });
    syncCount();
  }
  function onClick(e) {
    var b = e.target.closest('button, a'); if (!b || !host.contains(b)) return;
    if (b.hasAttribute('data-sai-ex')) { ui.input.value = b.getAttribute('data-sai-ex'); syncCount(); showErr(''); ui.input.focus(); return; }
    if (b.hasAttribute('data-sai-style')) { setStyle(b.getAttribute('data-sai-style')); return; }
    if (b.hasAttribute('data-sai-go')) { generate(false); return; }
    if (b.hasAttribute('data-sai-again')) { generate(true); return; }
    if (b.hasAttribute('data-sai-use')) { useDesign(b.getAttribute('data-sai-use')); return; }
    if (b.hasAttribute('data-sai-email-go')) { useEmail(); return; }
    if (b.hasAttribute('data-sai-page')) {
      var t = clean(ui.input.value);
      b.href = AI_PAGE + (t ? (AI_PAGE.indexOf('?') < 0 ? '?' : '&') + 'idea=' + encodeURIComponent(t.slice(0, MAX)) : '');
    }
  }
  function setStyle(st) {
    S.style = st;
    $$('[data-sai-style]').forEach(function (x) {
      var on = x.getAttribute('data-sai-style') === st;
      x.setAttribute('aria-checked', on ? 'true' : 'false'); x.tabIndex = on ? 0 : -1;
    });
    var s = STYLES.filter(function (x) { return x[0] === st; })[0];
    if (ui.note) ui.note.textContent = s ? s[1] + ': ' + s[2].charAt(0).toLowerCase() + s[2].slice(1) + '.' : '';
  }
  function syncCount() { ui.count.textContent = ui.input.value.length + '/' + MAX; }
  function showErr(m, elx) { var x = elx || ui.err; if (!x) return; x.textContent = m || ''; x.hidden = !m; }
  function setQuota() {
    if (S.ideasLeft == null) return;
    var n = S.ideasLeft;
    ui.quota.textContent = S.hasEmail
      ? (n > 0 ? n + ' idea' + (n === 1 ? '' : 's') + ' left today' : 'No ideas left today')
      : (n > 0 ? n + ' free idea' + (n === 1 ? '' : 's') + ' · no sign-up' : 'Add your email for 10 ideas a day');
  }
  function setBusy(on, label) {
    S.busy = on;
    ui.go.disabled = on || S.off; ui.again.disabled = on;
    ui.goLabel.textContent = on ? (label || 'Drawing…') : 'Make my stickers';
    $$('[data-sai-use]').forEach(function (x) { x.disabled = on; });
  }
  function startLoading() {
    setBusy(true, 'Drawing…');
    ui.results.hidden = false; ui.progress.hidden = false;
    ui.grid.innerHTML = '';
    for (var i = 0; i < 4; i++) { var c = document.createElement('div'); c.className = 'sai-card is-loading'; c.setAttribute('aria-hidden', 'true'); c.innerHTML = '<span class="sai-blob"></span>'; ui.grid.appendChild(c); }
    var t0 = Date.now(), k = 0, fill = ui.progress.firstElementChild;
    ui.status.textContent = LOADING[0];
    clearInterval(S.timer);
    S.timer = setInterval(function () {
      var t = (Date.now() - t0) / 1000;
      fill.style.width = Math.min(94, 100 * (1 - Math.exp(-t / 14))) + '%';
      if (Math.floor(t / 4) !== k && k < LOADING.length - 1) { k = Math.min(LOADING.length - 1, Math.floor(t / 4)); ui.status.textContent = LOADING[k]; }
    }, 250);
    showResultsArea();
  }
  // scroll the drawer (side panel on computers, bottom sheet on phones) so the designs are in view
  function showResultsArea() {
    var d = root.querySelector('[data-drawer]');
    if (!d || !ui.results) return;
    if (ui.results.offsetParent !== d) { try { ui.results.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); } catch (e) {} return; }
    var top = Math.max(0, ui.results.offsetTop - 12);
    try { d.scrollTo({ top: top, behavior: 'smooth' }); } catch (e) { d.scrollTop = top; }
  }
  function stopLoading() {
    clearInterval(S.timer);
    ui.progress.hidden = true; ui.progress.firstElementChild.style.width = '0';
    setBusy(false);
  }
  function renderResults(note) {
    ui.grid.innerHTML = '';
    if (!S.images.length) { ui.results.hidden = true; return; }
    ui.results.hidden = false;
    S.images.forEach(function (im, i) {
      var c = document.createElement('button');
      c.type = 'button'; c.className = 'sai-card' + (im.id === S.selected ? ' is-selected' : '');
      c.setAttribute('data-sai-use', im.id); c.setAttribute('aria-label', 'Use sticker design ' + (i + 1));
      c.innerHTML = '<span class="sai-card__art"><img alt="" decoding="async"></span><span class="sai-card__go">Use this design</span>';
      var img = c.querySelector('img');
      img.addEventListener('load', function () { c.classList.add('is-in'); });
      img.addEventListener('error', function () { c.classList.add('is-broken'); c.disabled = true; });
      img.src = im.url;
      ui.grid.appendChild(c);
    });
    ui.status.textContent = note || (S.images.length > 1 ? 'Tap the one you like best to put it on your sticker.' : 'Here you go. Tap it to put it on your sticker.');
  }
  function remember() {
    if (!S.ideaId) return;
    var hist = sget('wsIdeaHistory') || [];
    if (!Array.isArray(hist)) hist = [];
    var entry = { ideaId: S.ideaId, idea: S.idea, style: S.style, images: S.images.slice(0, 8), selected: S.selected, at: Date.now() };
    sset('wsIdeaHistory', [entry].concat(hist.filter(function (h) { return h && h.ideaId !== S.ideaId; })).slice(0, 6));
  }
  function openGate() {
    showErr('', ui.gateErr);
    ui.gate.hidden = false;
    ui.email.value = email || '';
    setTimeout(function () { try { ui.email.focus(); } catch (e) {} }, 60);
    track('ardor_idea_gate_shown', {});
  }
  function closeGate() { ui.gate.hidden = true; }
  function subscribe(addr) {
    var f = document.getElementById('ardor-sai-customer');
    if (!f) return;
    var field = f.querySelector('[name="contact[email]"]'); if (field) field.value = addr;
    f.target = 'ardor-sai-sink';
    try { if (f.requestSubmit) f.requestSubmit(); else f.submit(); } catch (e) { try { f.submit(); } catch (er) {} }
  }
  function useEmail() {
    var addr = clean(ui.email.value);
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(addr)) { showErr('Please enter a valid email.', ui.gateErr); ui.email.focus(); return; }
    showErr('', ui.gateErr);
    email = addr; lset('wsIdeaEmail', addr); S.hasEmail = true;
    subscribe(addr);
    track('ardor_idea_email', {});
    api('/api/quota?visitor=' + encodeURIComponent(visitor) + '&email=' + encodeURIComponent(addr), null, 20000).then(function (q) {
      if (q.ok) { S.ideasLeft = q.ideasLeft; S.editsLeft = q.editsLeft; }
      setQuota(); closeGate();
      var next = S.pending; S.pending = null;
      if (next && (S.ideasLeft == null || S.ideasLeft > 0)) next();
    });
  }

  // ---------- 4 designs, then the picked one goes on the sticker ----------
  function generate(again) {
    if (S.busy || S.off) return;
    var idea = clean(again ? S.idea.replace(/ \(changed: .*\)$/, '') : ui.input.value).slice(0, MAX);
    if (idea.length < 3) { showErr('Tell us a little more about your idea.'); ui.input.focus(); return; }
    showErr('');
    if (!S.hasEmail && S.ideasLeft === 0) { S.pending = function () { generate(again); }; openGate(); return; }
    var prev = { ideaId: S.ideaId, idea: S.idea, images: S.images, selected: S.selected };
    S.idea = idea;
    startLoading();
    botToken().then(function (token) {
      return api('/api/generate', { idea: idea, style: S.style, visitor: visitor, email: S.hasEmail ? email : '', token: token });
    }).then(function (j) {
      stopLoading();
      if (j.ideasLeft != null) S.ideasLeft = j.ideasLeft;
      if (!j.ok || !j.images || !j.images.length) {
        S.ideaId = prev.ideaId; S.idea = prev.idea; S.images = prev.images; S.selected = prev.selected;
        renderResults();
        if (j.error === 'need_email') { S.ideasLeft = 0; setQuota(); S.pending = function () { generate(again); }; openGate(); return; }
        showErr(j.message || 'We couldn\'t draw that one. Please try again.');
        setQuota();
        return;
      }
      S.ideaId = j.ideaId || ''; S.idea = j.idea || idea; S.images = j.images.slice(0, 8); S.selected = null;
      if (j.editsLeft != null) S.editsLeft = j.editsLeft;
      if ('hasEmail' in j) S.hasEmail = !!j.hasEmail;
      setQuota(); renderResults(); remember();
      track('ardor_idea_generated', { style: S.style, again: !!again });
    });
  }
  function useDesign(id) {
    if (S.busy) return;
    var img = S.images.filter(function (x) { return x.id === id; })[0], St = studio();
    if (!img || !/^[a-f0-9]{32}$/.test(id)) return;
    if (!St || !St.placeIdea) { showErr('Please reload the page and try again.'); return; }
    showErr('');
    S.selected = id;
    sset('wsIdeaPick', { id: img.id, url: img.url, idea: S.idea, style: S.style, at: Date.now() });
    remember();
    $$('[data-sai-use]').forEach(function (x) { var on = x.getAttribute('data-sai-use') === id; x.classList.toggle('is-selected', on); x.classList.toggle('is-placing', on); });
    setBusy(true, 'One moment…');
    ui.status.textContent = 'Putting your design on your sticker…';
    fetch(API + '/img/' + id).then(function (r) {
      if (!r.ok) throw new Error('gone');
      return r.blob();
    }).then(function (blob) {
      return St.placeIdea(id, S.idea, blob, 'drawer');
    }).then(function (res) {
      setBusy(false);
      $$('.sai-card.is-placing').forEach(function (x) { x.classList.remove('is-placing'); });
      if (!res || !res.obj) { ui.status.textContent = 'Tap the one you like best to put it on your sticker.'; showErr('We couldn\'t put that design on your sticker. Please try another one.'); return; }
      ui.status.textContent = 'This design is on your sticker. Tap another one to swap it.';
      track('ardor_idea_used', { style: S.style });
      if (St.isOpen && St.isOpen('ai') && St.closeDrawer) St.closeDrawer();
      if (!res.first && St.toast) St.toast('Your AI design is on your sticker. Move or resize it, or add text and clipart.', 7000);
    }).catch(function () {
      setBusy(false);
      $$('.sai-card.is-placing').forEach(function (x) { x.classList.remove('is-placing'); });
      ui.status.textContent = 'Tap the one you like best to put it on your sticker.';
      showErr('We couldn\'t load that design. It may have expired. Try another one or make new ones.');
    });
  }

  // ---------- opening the drawer ----------
  function start() {
    if (S.started) return;
    S.started = true;
    email = lget('wsIdeaEmail') || email; S.hasEmail = S.hasEmail || !!email;
    if (!API) { ui.go.disabled = true; showErr('AI design is not available right now. Please try again later.'); return; }
    quota();
    loadTurnstile();
    var last = (sget('wsIdeaHistory') || [])[0];
    if (last && last.images && last.images.length && !S.images.length) {
      S.ideaId = last.ideaId || ''; S.idea = String(last.idea || ''); S.images = last.images.slice(0, 8); S.selected = last.selected || null;
      setStyle(last.style || 'cartoon');
      ui.input.value = S.idea.replace(/ \(changed: .*\)$/, '').slice(0, MAX); syncCount();
      renderResults('Your latest designs. Tap one to put it on your sticker.');
    }
  }
  function isOpen() {
    var St = studio();
    if (St && St.isOpen) return St.isOpen('ai');
    var d = root.querySelector('[data-drawer]'), p = root.querySelector('[data-drawer-panel="ai"]');
    return !!(d && p && d.classList.contains('is-open') && p.classList.contains('is-active'));
  }
  var wasOpen = false;
  function onOpenChange() {
    var open = isOpen();
    if (open && !wasOpen) {
      start();
      if (wide() && !S.busy) { try { ui.input.focus({ preventScroll: true }); } catch (e) {} }
    }
    wasOpen = open;
  }
  function openAi() {
    var St = studio();
    if (!St || !St.openDrawer) return false;
    if (!St.isOpen('ai')) St.openDrawer('ai');
    return true;
  }

  build();
  // the "Describe your idea" links (empty state and the Files drawer) open this drawer instead of leaving the page;
  // without the studio they still go to the AI sticker idea generator page
  root.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-idea-link]');
    if (!a || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button > 0) return;
    if (openAi()) e.preventDefault();
  });
  var drawer = root.querySelector('[data-drawer]'), panel = root.querySelector('[data-drawer-panel="ai"]');
  if (drawer && panel && window.MutationObserver) {
    var mo = new MutationObserver(onOpenChange);
    mo.observe(drawer, { attributes: true, attributeFilter: ['class'] });
    mo.observe(panel, { attributes: true, attributeFilter: ['class'] });
  }
  window.ArdorStickerAI = { open: openAi, start: start, quota: quota, state: S, generate: generate, use: useDesign };
})();
